import { BaseService } from './base.service';

export class CartsService extends BaseService {
  static get resourceEndpoint() {
    return 'carts';
  }
}
